import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=9f6dff66&"
import script from "./Persona.vue?vue&type=script&lang=js&"
export * from "./Persona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports